import { render, staticRenderFns } from "./InvoicesTable.vue?vue&type=template&id=dcedbb86&scoped=true"
import script from "./InvoicesTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoicesTable.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoicesTable.vue?vue&type=style&index=0&id=dcedbb86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcedbb86",
  null
  
)

export default component.exports